export default {
  bar: {
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '75%',
      },
    },
    dataLabels: {
      enabled: true
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent']
    },
    xaxis: {
      categories: window.categories,
      labels: {
        trim: true,
        formatter(value) {
          return value;
        }
      }
    },
    fill: {
      opacity: 1
    },
  },
  column: {
    plotOptions: {
      bar: {
        horizontal: true,
        barHeight: '100%',
      },
    },
    dataLabels: {
      enabled: true
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent']
    },
    xaxis: {
      categories: window.categories,
      labels: {
        trim: true
      }
    },
    fill: {
      opacity: 1
    },
  }
}



// WEBPACK FOOTER //
// ./resources/js/components/trials/chart-options.js